<template>
  <div class="mobileCurriculum">
    <van-nav-bar
      :title="viewTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div
      class="video"
      :class="{ 'full-screen': fullScreen }"
      :style="{
        width: fullScreen ? fullScreenWidth + 'px' : '100%',
        height: fullScreen ? fullScreenHeight + 'px' : 'auto',
        top: fullScreen
          ? fullScreenWidth / 2 - fullScreenHeight / 2 - 25 + 'px'
          : 0,
        left: fullScreen ? -fullScreenWidth / 4 + 'px' : 0,
      }"
      style="text-align: center"
    >
      <video-player
        v-if="playerOptions.sources.length"
        class="video-player vjs-custom-skin"
        :class="{ aliving: videoType == 'liveing' }"
        :style="{
          width: fullScreen
            ? isHorizontal
              ? isiOS
                ? '70%'
                : '65%'
              : '90%'
            : '100%',
          padding: fullScreen ? '2%' : 0,
        }"
        style="display: inline-block"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @playing="onPlayerPlaying($event)"
        @pause="onPlayerPause($event)"
        @timeupdate="timeupdate"
        @seeking="onPlayerSeeking"
        @seeked="onPlayerSeeked"
        @ended="onPlayerEnded"
      >
      </video-player>
      <!-- @canplay="canplay($event)" -->
      <!-- @play="onPlayerPlay($event)" -->
    </div>
    <div class="video-list">
      <van-tabs v-model:active="activeTab">
        <van-tab title="简介">
          {{ description }}
        </van-tab>
        <van-tab title="课程目录">
          <div style="background: #f9f9f9; padding: 10px">
            <div class="video-item" v-for="(i, _i) in videos" :key="_i">
              <div class="video-title">{{ _i + 1 }}.{{ i.title }}</div>
              <div
                class="video-item-list"
                v-for="(s, _s) in i.coursewares"
                :key="_s"
                :class="{
                  active:
                    s.id == activeVideo && s.sectionId == actvieVideoSections,
                }"
                @click="viewViedo(s)"
              >
                <div class="main-title">
                  <el-icon style="margin-right: 5px">
                    <VideoCameraFilled />
                  </el-icon>
                  {{ s.title }}
                </div>
                <span class="timer">{{
                  formatterData(s.vedio.timeLength)
                }}</span>
                <p style="clear: both; font-size: 12px; line-height: 20px">
                  学习进度：{{
                    s.currentTime
                      ? "（" +
                        (
                          (s.currentTime / s.vedio.timeLength > 1
                            ? 1
                            : s.currentTime / s.vedio.timeLength) * 100
                        ).toFixed(2) +
                        "%）"
                      : s.isDone ? "（100%）" : ""
                  }}<span :class="s.isDone ? 'status-done' : 'status-undone'">{{ s.isDone ? "已完成" : "未完成" }}</span>
                </p>
              </div>
            </div>
          </div>
          <!-- <div
            class="video-item"
            v-for="(i, _i) in videos"
            :key="_i"
            @click="viewViedo(i.vedio, _i, i)"
            :class="{ active: _i == activeVideo }"
          >
            {{ i.title }}
            <span class="timer">{{ formatterData(i.vedio.timeLength) }}</span>
            <p style="font-size: 12px; line-height: 20px">学习进度：{{ i.isDone ? "已完成" : "未完成" }}</p>
          </div> -->
          <div class="empty" v-if="!videos.length">暂无课程视频</div>
        </van-tab>
        <van-tab title="视频直播">
          <div
            v-if="lives.length"
            style="margin-bottom: 20px; background: #f9f9f9; padding: 10px"
          >
            <div
              class="ailve-item"
              v-for="(i, _i) in lives"
              :key="_i"
              @click="viewIives(i, _i)"
              :class="{ active: activelives == _i }"
            >
              {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
              <div class="description">{{ i.aliveDate }}</div>
            </div>
          </div>
          <!-- <div
            class="ailve-item"
            v-for="(i, _i) in lives"
            :key="_i"
            @click="viewIives(i, _i)"
            :class="{ active: i.living }"
          >
            {{ i.living ? "【直播中】" : "【未开始】" }}{{ i.title }}
            <div class="description">{{ i.aliveDate }}</div> 
          </div>-->
          <div class="empty" v-if="!lives.length">暂无直播视频</div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { VideoCameraFilled } from "@element-plus/icons-vue";
let VideocurrentTime = 0;
export default {
  name: "curriculum",
  components: { VideoCameraFilled },
  data() {
    return {
      videoId: "",
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isHorizontal: false,
      httpsLocation:
        // "https://tecsf.marsontec.com",
        "https://tecsf.gdcoh.com",
      activeTabsNames: "second",
      videoType: "",
      viewTitle: "",
      description: "",
      videos: [],
      activeVideo: 0,
      lives: [],
      activelives: "",
      livesVideo: null,
      fullScreen: false,
      fullScreenWidth: document.documentElement.clientHeight,
      fullScreenHeight: document.documentElement.clientWidth,
      playerPlaying: false,
      lastValidPlaybackTime: 0,
      seekingBlocked: false,
      seekRestoreTimer: null,
      lastSeekWarningAt: 0,
      tabLockId: "",
      lockStorageKey: "",
      lockHeartbeatTimer: null,
      lockHeartbeatMs: 10000,
      lockExpireMs: 60000,
      hasCourseLock: false,
      lockBlocked: false,
      lockListenerBound: false,
      // 课件完成判定相关：达到该比例后尝试触发一次“完成”上报，由后端统一校验
      coursewareCompleteThreshold: 0.8,
      hasTriedCompleteOnce: false,
      // 课件进度上报节流
      lastCoursewareProgressReportTime: 0,
      coursewareProgressThrottleMs: 10000,
      playerOptions: {
        //播放速度
        playbackRates: [],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频·。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          // {
          //   //类型
          //   type: "video/mp4",
          //   //url地址
          //   src: "https://media.w3.org/2010/05/sintel/trailer.mp4",
          // },
        ],
        //你的封面地址
        // poster:
        // "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F1812.img.pp.sohu.com.cn%2Fimages%2Fblog%2F2009%2F11%2F18%2F18%2F8%2F125b6560a6ag214.jpg&refer=http%3A%2F%2F1812.img.pp.sohu.com.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1624024420&t=606e426a40c26ff068470eabe257afab",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: false,
        },
      },
      currentTime: 0, // 默认直播重头开始
      examDetail: null, //考试详情
      activeTab: 1,
      courseDetail: null, //课程详情
    };
  },
  created() {
    this.videoId = this.$route.query && this.$route.query.id;
    this.cleanOtherUsersCache(); // 清理其他用户的缓存
    // 已取消单窗口限制，直接初始化数据
    this.initData();
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.seekRestoreTimer) {
      clearTimeout(this.seekRestoreTimer);
      this.seekRestoreTimer = null;
    }
    // 已取消单窗口限制，不再释放锁
  },
  methods: {
    // 清理其他用户的缓存数据，节省localStorage空间
    cleanOtherUsersCache() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      if (!userInfo.userName) return;

      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只保留当前用户的缓存数据
      const currentUserCache = list.filter(
        (el) => el.userName === userInfo.userName
      );
      
      // 如果数据有变化才更新（避免不必要的写入）
      if (currentUserCache.length !== list.length) {
        this.$storage.setStorage([
          {
            key: "vidoDataList",
            value: currentUserCache,
          },
        ]);
      }
    },
    initializeCourseLock() {
      // 已取消单窗口限制，此方法不再执行任何操作
      // 保留方法定义以避免可能的调用错误
    },
    generateTabLockId() {
      return `${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
    },
    getCourseLockStorageKey() {
      const courseId = this.$route.query && this.$route.query.id;
      return courseId ? `course_tab_lock_${courseId}` : "";
    },
    parseLockPayload(value) {
      if (!value) return null;
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    getCurrentLockPayload() {
      if (!this.lockStorageKey || typeof window === "undefined") return null;
      return this.parseLockPayload(localStorage.getItem(this.lockStorageKey));
    },
    isLockExpired(payload) {
      if (!payload || !payload.timestamp) return true;
      return Date.now() - payload.timestamp > this.lockExpireMs;
    },
    writeLockPayload(payload) {
      if (!this.lockStorageKey || typeof window === "undefined") return;
      localStorage.setItem(this.lockStorageKey, JSON.stringify(payload));
    },
    acquireCourseLock() {
      // 已取消单窗口限制，始终返回 true 表示获取成功
      return true;
    },
    startLockHeartbeat() {
      // 已取消单窗口限制，不再启动心跳机制
      // 清理可能存在的旧定时器
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    stopLockHeartbeat() {
      if (this.lockHeartbeatTimer) {
        clearInterval(this.lockHeartbeatTimer);
        this.lockHeartbeatTimer = null;
      }
    },
    releaseCourseLock(removeEntry = true) {
      // 已取消单窗口限制，仅清理可能存在的定时器
      this.stopLockHeartbeat();
    },
    handleLockStorageEvent(event) {
      // 已取消单窗口限制，不再处理锁相关事件
    },
    handleLockDenied() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    handleLockLost() {
      // 已取消单窗口限制，此方法不再执行任何操作
    },
    notifyLockConflict(message) {
      const redirect = () => {
        this.$router.replace({
          path: "/courseDetail",
          query: {
            id: this.$route.query.id,
            courseId: this.$route.query.courseId,
          },
        });
      };
      if (this.$dialog?.alert) {
        this.$dialog
          .alert({
            title: "提示",
            message,
          })
          .finally(redirect);
      } else if (this.$toast) {
        this.$toast(message);
        redirect();
      } else {
        redirect();
      }
    },
    ensureCourseLockActive() {
      // 已取消单窗口限制，始终返回 true 允许操作
      return true;
    },
    handleBeforeUnload() {
      // 已取消单窗口限制，不再释放锁
    },
    getActiveCourseware() {
      const section = this.videos.find(
        (el) => el.id == this.actvieVideoSections
      );
      if (!section) {
        return null;
      }
      return section.coursewares.find((item) => item.id == this.activeVideo) || null;
    },
    getActiveCoursewareDuration() {
      const courseware = this.getActiveCourseware();
      if (!courseware || !courseware.vedio) {
        return 0;
      }
      return Number(courseware.vedio.timeLength) || 0;
    },
    clampPlaybackTime(rawTime, { updateTracker = true } = {}) {
      const duration = this.getActiveCoursewareDuration();
      const numeric = Math.max(Number(rawTime) || 0, 0);
      const safeTime = duration ? Math.min(numeric, duration) : numeric;
      if (updateTracker && safeTime > this.lastValidPlaybackTime) {
        this.lastValidPlaybackTime = safeTime;
      }
      return safeTime;
    },
    timeupdate(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType != "liveing") {
        const rawTime = player.cache_.currentTime;
        const safeTime = this.clampPlaybackTime(rawTime);
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: safeTime || null,
          },
          () => {},
          true
        );
        if (!this.currentPlayTimer || !this.currentPlayStatus) {
          this.videos.forEach((el) => {
            if (el.id == this.actvieVideoSections) {
              el.coursewares.forEach((item) => {
                if (item.id == this.activeVideo && !item.isDone) {
                  this.currentPlayTimer = item.vedio.timeLength;
                  item.currentTime = safeTime;
                }
              });
            }
          });
          this.currentPlayStatus = this.currentPlayTimer
            ? safeTime / this.currentPlayTimer >= 1.0
            : false;
          if (this.currentPlayStatus) {
            this.onPlayerEnded();
          }
          VideocurrentTime = safeTime;
        }

        // 周期性向后端上报课件播放进度（单位：秒），用于统一的完成判定
        const now = Date.now();
        if (
          this.videoId &&
          this.activeVideo &&
          (!this.lastCoursewareProgressReportTime ||
            now - this.lastCoursewareProgressReportTime >=
              this.coursewareProgressThrottleMs)
        ) {
          this.lastCoursewareProgressReportTime = now;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${this.videoId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .catch(() => {});
        }

        // 当本课件已观看比例首次达到阈值时，尝试触发一次“完成”上报
        const duration = this.getActiveCoursewareDuration();
        if (
          duration &&
          !this.hasTriedCompleteOnce &&
          safeTime / duration >= this.coursewareCompleteThreshold
        ) {
          this.hasTriedCompleteOnce = true;
          // 先同步当前进度到后端，确保后端有最新的观看时间
          // 这避免了完成上报时后端进度滞后导致的验证失败
          const courseId = this.$route.query && this.$route.query.id;
          this.$https
            .put(
              `/api/my/course/coursewareProgress/${courseId}/${this.activeVideo}`,
              { currentTime: safeTime }
            )
            .finally(() => {
              // 无论进度上报成功与否，都尝试上报完成状态
              // 传递 currentTime 确保后端能获取最新进度（即使进度同步失败）
              // 复用课程进度计算逻辑：以当前课件进度作为本课件的完成占比
              let completedCourses = 0;
              let totalCourses = 0;
              this.videos.forEach((section) => {
                if (section.coursewares) {
                  section.coursewares.forEach((courseware) => {
                    totalCourses++;
                    if (courseware.isDone || courseware.id === this.activeVideo) {
                      completedCourses++;
                    }
                  });
                }
              });
              const learningProgress =
                totalCourses > 0
                  ? ((completedCourses / totalCourses) * 100).toFixed(2)
                  : 0;
              this.reportCoursewareCompletion(learningProgress, 0, safeTime);
            });
        }

      }
    },
    onClickLeft() {
      // 从播放页返回课程详情时标记需要刷新，确保总学习进度等数据是最新的（含 keep-alive 场景）
      try {
        localStorage.setItem("needRefreshCourseDetail", "true");
      } catch (e) {}
      this.$router.replace({
        path: "/courseDetail",
        query: {
          id: this.$route.query.id,
          courseId: this.$route.query.courseId,
        },
      });
    },
    formatterData(time) {
      if (!time) {
        return "-";
      }
      const min = Math.floor(time % 3600); //分钟
      return (
        (Math.floor(time / 3600) ? Math.floor(time / 3600) + "时" : "") +
        (Math.floor(min / 60) ? Math.floor(min / 60) + "分" : "") +
        ((time % 60) + "秒")
      );
    },
    initData() {
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      const list = this.$storage.getStorage("vidoDataList") || [];
      // 只获取当前用户的缓存数据
      const videoHistoryMap = {};
      list
        .filter((el) => el.userName === userInfo.userName)
        .map((el) => (videoHistoryMap[el.activeVideoID] = el.time));
      const id = this.$route.query && this.$route.query.id;
      this.$https.get("/api/my/course/details/" + id).then((res) => {
        if (res.success) {
          const data = res.data;
          let videoing = false;
          this.description = data.description;
          // 直播
          let _lives = data.lives.map((el) => {
            return {
              ...el,
              ...this.judeLives(res, el),
            };
          });
          this.lives = _lives
            .filter((el) => el.living)
            .concat(_lives.filter((el) => !el.living));
          this.lives.forEach((el, _el) => {
            if (el.living) {
              videoing = true;
              this.viewIives(el, _el);
            }
          });
          // 视频
          this.videos = data.courseSections.map((el) => {
            return {
              ...el,
              coursewares: data.coursewares
                .filter((item) => item.sectionId == el.id)
                .map((val) => {
                  val.currentTime = videoHistoryMap[val.id];
                  if (!val.isDone && !videoing) {
                    videoing = true;
                    this.viewViedo(val);
                  }
                  return val;
                }),
            };
          });
          if (!videoing) {
            data.courseSections.map((el, _el) => {
              data.coursewares
                .filter((item) => item.sectionId == el.id)
                .map((val) => {
                  if (!_el) {
                    videoing = true;
                    this.viewViedo(val);
                  }
                });
            });
          }
          // 兼容历史遗留数据：检查并修复已学完但未标记完成的课件
          this.fixHistoricalCoursewareProgress(data.coursewares, id);
        }
      });
    },
    // 上报课件完成状态（带重试机制）
    reportCoursewareCompletion(learningProgress, retryCount = 0, currentTime = null) {
      const courseId = this.$route.query && this.$route.query.id;
      if (!courseId || !this.activeVideo) {
        return Promise.resolve();
      }
      // 如果有 currentTime，一并传递给后端（解决进度同步失败的问题）
      let url = `/api/my/course/coursewareDone/${courseId}/${this.activeVideo}?progress=${learningProgress}&completed=true`;
      if (currentTime != null && currentTime > 0) {
        url += `&currentTime=${currentTime}`;
      }
      
      return this.$https.put(url)
        .then(() => {
          // 上报成功，重置重试计数
          this.completionRetryCount = 0;
          this.pendingCompletionReport = null;
          // 以服务器为准：重新拉取课程详情，用服务端返回的 isDone 更新列表，只有成功落库才算“已完成”
          const id = this.$route.query && this.$route.query.id;
          if (id) {
            this.$https.get("/api/my/course/details/" + id).then((res) => {
              if (res.success && res.data && res.data.coursewares) {
                const map = {};
                res.data.coursewares.forEach((cw) => {
                  map[cw.id] = cw.isDone;
                });
                this.videos.forEach((section) => {
                  (section.coursewares || []).forEach((cw) => {
                    if (Object.prototype.hasOwnProperty.call(map, cw.id)) {
                      cw.isDone = map[cw.id];
                    }
                  });
                });
                this.$forceUpdate?.();
                this.checkAllVideosComplete();
              }
            });
          }
        })
        .catch((error) => {
          // 如果是完成状态上报失败，且未超过最大重试次数，则重试
          if (retryCount < this.maxCompletionRetries) {
            const delay = this.completionRetryDelayMs * Math.pow(2, retryCount); // 指数退避
            this.pendingCompletionReport = {
              learningProgress: learningProgress,
              retryCount: retryCount + 1,
              currentTime: currentTime,
              delay: delay
            };
            console.warn(`[课件完成上报] 失败，${delay}ms 后重试 (${retryCount + 1}/${this.maxCompletionRetries}):`, error);
            setTimeout(() => {
              if (this.pendingCompletionReport) {
                this.reportCoursewareCompletion(
                  this.pendingCompletionReport.learningProgress,
                  this.pendingCompletionReport.retryCount,
                  this.pendingCompletionReport.currentTime
                );
              }
            }, delay);
          } else {
            // 超过最大重试次数，记录到本地，等待页面加载时修复
            console.error(`[课件完成上报] 超过最大重试次数，将在页面加载时自动修复`);
            this.pendingCompletionReport = {
              learningProgress: learningProgress,
              retryCount: retryCount,
              currentTime: currentTime,
              delay: 0
            };
          }
        });
    },
    // 修复历史遗留数据：自动补传已完成但后台未标记的课件
    // 同时处理网络失败导致的上报失败情况
    fixHistoricalCoursewareProgress(coursewares, courseId) {
      if (!coursewares || !Array.isArray(coursewares) || !courseId) {
        return;
      }
      coursewares.forEach((courseware) => {
        // 检查条件：课件有视频时长，且播放进度达到完成阈值（80%），但后台未标记为完成
        if (
          courseware.vedio &&
          courseware.vedio.timeLength &&
          courseware.currentTime != null &&
          courseware.currentTime / courseware.vedio.timeLength >= this.coursewareCompleteThreshold &&
          !courseware.isDone
        ) {
          // 计算总学习进度：已完成的课程 + 当前课件（假设已完成）/全部课程*100
          let completedCourses = 0;
          let totalCourses = 0;
          coursewares.forEach((cw) => {
            totalCourses++;
            if (cw.isDone || (cw.id === courseware.id)) {
              completedCourses++;
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 为当前课件单独调用接口，补传completed=true
          // 传递 currentTime 确保后端能获取最新进度
          this.$https
            .put(
              "/api/my/course/coursewareDone/" +
                courseId +
                "/" +
                courseware.id +
                "?progress=" +
                learningProgress +
                "&completed=true" +
                "&currentTime=" +
                (courseware.currentTime || courseware.vedio?.timeLength || 0)
            )
            .then(() => {
              console.log(`[自动修复] 课件 ${courseware.id} 完成状态已修复`);
              // 补传成功后立即更新当前页对应课件的 isDone，避免“重新进来仍显示未完成”
              courseware.isDone = true;
              this.$forceUpdate?.();
            })
            .catch((error) => {
              console.warn(`[自动修复] 课件 ${courseware.id} 完成状态修复失败，将在下次页面加载时重试:`, error);
            });
        }
      });
    },
    onPlayerPlaying() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (!this.playerPlaying) {
        this.playerPlaying = true;
        this.initFullScreem();
        this.onPlayerPlay();
        console.log("开始播放了");
        // this.$refs.videoPlayer.player.currentTime(this.currentTime);
      }
    },
    // 播放回调
    onPlayerPlay() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        this.$refs.videoPlayer.player.currentTime(this.currentTime);
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
          },
          (list, listIndex) => {
            const resumeTime = list[listIndex].time || 0;
            const safeTime = this.clampPlaybackTime(resumeTime);
            this.$refs.videoPlayer.player.currentTime(safeTime);
          }
        );
      }
    },
    // 暂停回调
    onPlayerPause(player) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      console.log(this.$refs.videoPlayer);
      const safeTime = this.clampPlaybackTime(player.cache_.currentTime);
      this.currentTime = safeTime;
      this.setVidoData(
        {
          detailsID: this.videoId,
          activeVideoID: this.activeVideo,
          time: safeTime,
        },
        () => {},
        true
      );
    },
    onPlayerSeeking() {
      // 已取消单窗口限制，但保留快进检测机制
      if (this.videoType === "liveing") {
        return;
      }
      const playerInstance = this.$refs.videoPlayer?.player;
      if (!playerInstance) return;
      const requestedTime = playerInstance.currentTime();
      const tolerance = 0.5;
      if (requestedTime > this.lastValidPlaybackTime + tolerance) {
        this.seekingBlocked = true;
        const restoreTime = this.lastValidPlaybackTime;
        if (this.seekRestoreTimer) {
          clearTimeout(this.seekRestoreTimer);
        }
        this.seekRestoreTimer = setTimeout(() => {
          playerInstance.currentTime(restoreTime);
          this.seekRestoreTimer = null;
        }, 0);
        const now = Date.now();
        if (now - this.lastSeekWarningAt > 3000 && this.$toast) {
          this.$toast("当前课程不支持快进");
          this.lastSeekWarningAt = now;
        }
      }
    },
    onPlayerSeeked() {
      if (this.seekingBlocked) {
        this.seekingBlocked = false;
      }
    },
    onPlayerEnded() {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      if (this.videoType == "liveing") {
        let target = this.lives[this.activelives];
        let url =
          target.vedios.length > target.livingIndex + 1
            ? target.vedios[target.livingIndex + 1].url
            : "";
        target.livingIndex += 1;
        if (!url) this.playerOptions.notSupportedMessage = "已经结束！";
        this.playerOptions.sources = [
          {
            type:
              this.httpsLocation + url.indexOf(".m3u8")
                ? "application/x-mpegURL"
                : "video/mp4",
            src: url ? this.httpsLocation + url : "",
          },
        ];
      } else {
        this.setVidoData(
          {
            detailsID: this.videoId,
            activeVideoID: this.activeVideo,
            time: 0,
          },
          () => {},
          true
        );
        this.lastValidPlaybackTime = 0;
        let data = this.videos
          .find((el) => el.id == this.actvieVideoSections)
          .coursewares.find((el) => el.id == this.activeVideo);

        // 计算总学习进度：已完成的课程 + 当前正在看的课程（如果未完成）/全部课程*100
        let completedCourses = 0;
        let totalCourses = 0;

        this.videos.forEach((section) => {
          if (section.coursewares) {
            section.coursewares.forEach((courseware) => {
              totalCourses++;
              if (courseware.isDone) {
                completedCourses++;
              }
            });
          }
        });

        // 如果当前课程未完成，则在已完成数量基础上加1
        if (!data.isDone) {
          completedCourses++;
        }
        // 学习进度百分比
        const learningProgress =
          totalCourses > 0
            ? ((completedCourses / totalCourses) * 100).toFixed(2)
            : 0;
        if (data.isDone) return;

        // 视频播放完成，传递完整的视频时长作为 currentTime
        const videoDuration = data.vedio?.timeLength || 0;
        this.$https
          .put(
            "/api/my/course/coursewareDone/" +
              this.$route.query.id +
              "/" +
              data.id +
              "?progress=" +
              learningProgress +
              "&completed=true" +
              "&currentTime=" +
              videoDuration
          )
          .then(() => {
            this.videos.forEach((el) => {
              if (el.id == this.actvieVideoSections) {
                el.coursewares.forEach((item) => {
                  if (item.id == this.activeVideo) {
                    item.isDone = true;
                  }
                });
              }
            });

            // 检查是否所有视频都已完成
            this.checkAllVideosComplete();
          });
      }
    },
    //获取课程详情 判断是否有考试
    async getExamDetail() {
      const courseId = this.$route.query && this.$route.query.courseId;
      const res = await this.$https.get(`/api//my/registration/${courseId}`);
      if (res.success) {
        this.courseDetail = res.data;
        this.examDetail = res.data?.exam[0] || null;
      }
    },
    // 检查是否所有视频都已完成
    async checkAllVideosComplete() {
      let allVideosComplete = true;

      // 遍历所有章节和课件
      for (let section of this.videos) {
        if (section.coursewares) {
          for (let courseware of section.coursewares) {
            if (!courseware.isDone) {
              allVideosComplete = false;
              break;
            }
          }
        }
        if (!allVideosComplete) break;
      }
      if (allVideosComplete) {
        await this.getExamDetail();
      }
      //考试需要监考 不展示弹窗
      if (this.examDetail?.originExam?.needCam) {
        return;
      }

      // 显示考试提示弹窗
      if (allVideosComplete && this.examDetail?.examId) {
        // 判断考试时间是否已开始
        const currentTime = new Date().getTime();
        const examStartTime = this.examDetail.originExam?.startDate;
        const examEndTime = this.examDetail.originExam?.endDate;

        if (examStartTime && examEndTime) {
          if (currentTime >= examStartTime && currentTime <= examEndTime) {
            // 考试时间已开始，显示弹窗
            this.showExamDialog();
          }
        }
      }
    },
    // 显示考试提示弹窗
    showExamDialog() {
      this.$dialog
        .confirm({
          title: "学习完成",
          message: "恭喜您已完成课程学习！是否立即考试？",
          confirmButtonText: "立即考试",
          cancelButtonText: "稍后考试",
          confirmButtonColor: "#1989fa",
        })
        .then(() => {
          this.goToExam();
        });
    },
    // 跳转到考试页面
    goToExam() {
      this.$router.push({
        path: "/mobileExamination",
        query: {
          title: this.examDetail?.examTitle || "",
          examinationId: this.examDetail?.examId,
        },
      });
    },
    // 直播
    viewIives(item, i) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      this.playerPlaying = false;
      this.videoType = "liveing";
      if (!item.living) {
        this.$message({
          message: "尚未开始或已经结束",
          type: "warning",
        });
        return;
      }
      this.viewTitle = item.title;
      this.activelives = i;
      this.playerOptions.sources = [
        {
          type:
            this.httpsLocation +
            item.vedios[item.livingIndex].url.indexOf(".m3u8")
              ? "application/x-mpegURL"
              : "video/mp4",
          src: this.httpsLocation + item.vedios[item.livingIndex].url,
        },
      ];
      this.currentTime =
        item.currentTime + (moment().valueOf() - item.ajaxTime) / 1000;

      this.$https
        .put(
          "/api/my/course/liveRecord/" + this.$route.query.id + "/" + item.id
        )
        .then((res) => {
          console.log("liveRecord-mobile");
          console.log(res);
        })
        .catch((err) => {
          console.log("liveRecord-mobile-error");
          console.log(err);
        });
    },
    // 视频
    viewViedo(item) {
      if (!this.ensureCourseLockActive()) {
        return;
      }
      // 如果本地状态是已看完，切换时调用done接口，避免网络问题导致状态未同步
      if (item.isDone) {
        const courseId = this.$route.query && this.$route.query.id;
        if (courseId && item.id) {
          // 计算总学习进度
          let completedCourses = 0;
          let totalCourses = 0;
          this.videos.forEach((section) => {
            if (section.coursewares) {
              section.coursewares.forEach((courseware) => {
                totalCourses++;
                if (courseware.isDone) {
                  completedCourses++;
                }
              });
            }
          });
          const learningProgress =
            totalCourses > 0
              ? ((completedCourses / totalCourses) * 100).toFixed(2)
              : 0;
          // 调用done接口，传递 currentTime 确保后端能获取最新进度
          const itemCurrentTime = item.currentTime || item.vedio?.timeLength || 0;
          this.$https
            .put(
              `/api/my/course/coursewareDone/${courseId}/${item.id}?progress=${learningProgress}&completed=true&currentTime=${itemCurrentTime}`
            )
            .catch(() => {
              // 静默失败，不影响用户体验
            });
        }
      }
      this.playerPlaying = false;
      this.currentTime = 0;
      this.currentPlayTimer = 0;
      this.currentPlayStatus = false;
      this.hasTriedCompleteOnce = false;
      this.videoType = "video";
      this.activelives = null;
      this.viewTitle = item.title;
      this.actvieVideoSections = item.sectionId;
      this.activeVideo = item.id;
      const resumeTime = item.currentTime || 0;
      const safeTime = this.clampPlaybackTime(resumeTime);
      this.lastValidPlaybackTime = safeTime;
      item.currentTime = safeTime;
      this.seekingBlocked = false;
      if (this.seekRestoreTimer) {
        clearTimeout(this.seekRestoreTimer);
        this.seekRestoreTimer = null;
      }
      this.playerOptions.sources = [
        {
          type: "video/mp4",
          src: this.httpsLocation + item.vedio.url,
        },
      ];
    },
    // 判断是否有直播数据
    judeLives(res, item) {
      let isAlive = false;
      let startTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.startTime + ":00"
      ).valueOf();
      let endTime = moment(
        moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
      ).valueOf();
      if (startTime >= endTime) {
        endTime = moment(
          moment().format("YYYY-MM-DD") + " " + item.endTime + ":00"
        )
          .add(1, "d")
          .valueOf();
      }
      let aliveDate;
      // 判断日期
      Object.keys(item.dateSettings).forEach((el) => {
        let target = item.dateSettings[el];
        if (target) {
          switch (el) {
            case "monthDays":
              if (target.includes(moment(parseInt(res.stime)).format("DD"))) {
                isAlive = true;
              }
              aliveDate =
                "每月" +
                target.map((el) => el + 1).join(",") +
                "号 " +
                item.startTime +
                " 开始";
              break;
            case "specDays":
              target = target.map((el) =>
                moment(parseInt(el)).format("YYYY-MM-DD")
              );
              if (
                target.includes(
                  moment(parseInt(res.stime)).format("YYYY-MM-DD")
                )
              ) {
                isAlive = true;
              }
              aliveDate = target.join(",") + " " + item.startTime + " 开始";
              break;
            case "weeklyDays":
              if (target.includes(moment(parseInt(res.stime)).day())) {
                isAlive = true;
              }
              aliveDate =
                "每周" +
                target.map((el) => getWeekDate(el)).join(",") +
                " " +
                item.startTime +
                " 开始";
              break;
          }
        }
      });
      // 判断时间
      if (isAlive) {
        if (!(res.stime >= startTime && res.stime <= endTime)) {
          isAlive = false;
        }
      }
      // 计算直播播放时间,直播开始时间减去当前服务器时间得到已经开始的时间
      let currentTime = (res.stime - startTime) / 1000;
      let _currentTime = 0;
      let timeLength = 0;
      let livingIndex = 0;
      if (isAlive) {
        for (let i = 0; i <= item.vedios.length; i++) {
          if (timeLength >= currentTime) {
            livingIndex = i;
            _currentTime =
              item.vedios[i - 1].timeLength - (timeLength - currentTime);
            break;
          }
          timeLength += item.vedios[i].timeLength;
        }
      }
      return {
        currentTime: _currentTime,
        living: isAlive,
        // living: true,
        livingIndex: livingIndex ? livingIndex - 1 : 0,
        aliveDate: aliveDate,
        stime: res.stime,
        ajaxTime: moment().valueOf(),
      };
    },
    setVidoData(options, callBack, isSet = false) {
      if (!this.ensureCourseLockActive()) {
        return false;
      }
      const userInfo =
        (sessionStorage.getItem("userInfo") &&
          JSON.parse(sessionStorage.getItem("userInfo"))) ||
        {};
      // 如果是直接不保存数据
      if (this.videoType == "liveing") {
        return false;
      }
      // 保存当前数据到本地（用于保存回显视频地址和位置）
      let list = this.$storage.getStorage("vidoDataList") || [];
      // 只查找当前用户的缓存记录
      let listIndex = list.findIndex(
        (p) =>
          Number(p.detailsID) === Number(options.detailsID) &&
          Number(p.activeVideoID) === Number(options.activeVideoID) &&
          userInfo.userName == p.userName
      );
      if (listIndex !== -1) {
        if (callBack) {
          callBack([...list], listIndex);
        }
        if (isSet) {
          list[listIndex] = {
            detailsID: Number(options.detailsID),
            activeVideoID: Number(options.activeVideoID),
            time: options.time != null ? options.time : list[listIndex].time,
            timeLength: options.timeLength || 0,
            userName: userInfo.userName,
          };
        }
      } else {
        list.push({
          detailsID: Number(options.detailsID),
          activeVideoID: Number(options.activeVideoID),
          time: options.time || 0,
          timeLength: options.timeLength || 0,
          userName: userInfo.userName,
        });
      }
      this.$storage.setStorage([
        {
          key: "vidoDataList",
          value: list,
        },
      ]);
    },
    initFullScreem() {
      this.$nextTick(() => {
        setTimeout(() => {
          const contain = document.getElementsByClassName("vjs-control-bar")[0];
          let newDom = document.createElement("div");
          newDom.setAttribute("class", "vjs-control");
          newDom.setAttribute("style", "position: absolute;right: 0;");
          newDom.innerHTML =
            '<span class="ep-icon-fullscreen" style="margin-top:8px;font-size: 16px;display:inline-flex;align-items:center;"><svg viewBox="0 0 1024 1024" width="1em" height="1em"><path d="M384 128v128H192v192H64V128h320zm192 0h320v320H768V256H576V128zm-192 576v192H64V576h128v128h192zm576-192v320H640V832h192V640h128z" fill="currentColor"/></svg></span>';
          contain.append(newDom);
          newDom.addEventListener("click", () => {
            this.fullScreen = !this.fullScreen;
          });
        }, 1000);
      });
    },
  },

  mounted() {
    const that = this;
    // 移动端的浏览器一般都支持window.orientation这个参数，通过这个参数可以判断出手机是处在横屏还是竖屏状态。
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      function () {
        if (window.orientation === 180 || window.orientation === 0) {
          that.isHorizontal = false;
        }
        if (window.orientation === 90 || window.orientation === -90) {
          that.isHorizontal = true;
        }
      },
      false
    );
  },
};

function getWeekDate(date) {
  const list = [
    { name: "星期日", value: 0 },
    { name: "星期一", value: 1 },
    { name: "星期二", value: 2 },
    { name: "星期三", value: 3 },
    { name: "星期四", value: 4 },
    { name: "星期五", value: 5 },
    { name: "星期六", value: 6 },
  ];
  return list.find((el) => el.value == date).name;
}
</script>
<style lang="less">
.mobileCurriculum {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  .video {
    position: relative;
  }
  @media all and (orientation: portrait) {
    .full-screen {
      transform: rotate(90deg);
      -ms-transform: rotate(90deg); /* IE 9 */
      -moz-transform: rotate(90deg); /* Firefox */
      -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
      -o-transform: rotate(90deg); /* Opera */
      position: fixed;
      z-index: 10000;
      background-color: #000;
    }
  }

  @media all and (orientation: landscape) {
    .full-screen {
      position: fixed;
      z-index: 10000;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      background-color: #000;
    }
  }
  .warning {
    width: 100%;
    background: #d4d8df;
    text-align: center;
    color: #da2828;
    height: 100%;
    padding: 10px;
  }
  .video-list {
    font-size: 18px;
    .van-tab__panel {
      padding: 10px 20px;
      .video-item {
        cursor: pointer;
        line-height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        border-bottom: 1px solid #e4e7ed;
        font-weight: normal;
        color: #333333;
        .video-item-list {
          padding-left: 10px;
          padding-top: 8px;
          padding-bottom: 8px;
        }
        .main-title {
          width: 75%;
          float: left;
          // overflow: hidden;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // word-wrap: break-word;
          white-space: normal;
        }
        .timer {
          width: 25%;
          text-align: right;
          float: right;
        }
        .status-done {
          display: inline-block;
          margin-left: 4px;
          padding: 2px 8px;
          font-size: 12px;
          font-weight: 600;
          color: #fff;
          background: #52c41a;
          border-radius: 4px;
        }
        .status-undone {
          margin-left: 4px;
          color: #666;
          font-size: 12px;
        }
      }
      .ailve-item {
        cursor: pointer;
        line-height: 40px;
        border-bottom: 1px solid #e4e7ed;
        color: #b0b9ca;
        font-weight: bold;
        font-size: 18px;
        .description {
          font-size: 16px;
          font-weight: normal;
        }
      }
      .active {
        color: #0a73c5;
        .description {
          color: #677897;
        }
      }
    }
  }
}

.van-tab {
  font-size: 18px;
}

.vjs-progress-control {
  display: none !important;
}
.vjs-fullscreen-control {
  position: absolute;
  right: 0;
}
.aliving {
  .vjs-play-control {
    display: none !important;
  }
  .vjs-current-time {
    display: none !important;
  }
  .vjs-tech {
    pointer-events: none;
  }
  .timeout-lives {
    text-align: center;
  }
}
</style>
